export default function SkeletonFAQSection() {
  return (
    <section className="faq_section section_padding" aria-busy="true" aria-label="Loading FAQ">
      <div className="container">
        <div className="faq-card-wrap">
          <div className="content mb-8">
            <div className="faq-question-mark mb-4">
              <div className="w-12 h-12 rounded-full bg-gray-300 animate-pulse"></div>
            </div>
            <div className="mb-2 h-8 w-64 bg-gray-300 rounded animate-pulse"></div>
            <div className="h-4 w-96 bg-gray-300 rounded animate-pulse"></div>
          </div>

          <div className="accordion space-y-4">
            {[1, 2, 3, 4].map((item) => (
              <div
                key={item}
                className="faq-item border-b border-gray-200 pb-4"
                aria-label="Loading FAQ item"
              >
                <div className="h-6 w-3/4 bg-gray-300 rounded animate-pulse mb-2"></div>
                <div className="h-4 w-full max-w-xl bg-gray-300 rounded animate-pulse"></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
